import React from "react";
import BackToStandardList from "../BackToStandardList";

import {
  Avatar,
  Tooltip,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core";
import {
  PageWrapper,
  LeftColumn,
  RightColumn,
  DetailsTypography,
  StyledExpansionPanel,
  FirstLineWrapper,
  StyledTypography,
  StyledParagraphBold,
  TextWrapper,
  LongDivider,
} from "../FuiStyles";
import ConfigurationType from "../ConfigurationType";
import { ProductsInfomation } from "../Constants/ProductsInfomation";
import {
  ProductsInformationPam,
  ProductsInformationMcc,
} from "../Constants/ProductsInformationOtherIntiatives";
import BookIcon from "@material-ui/icons/Book";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

/**
 * Automatic Ticket Resolver form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: AppStepper
 */

//Choose a configuration type and enter into quick or full configuration components
const GeneralForm = ({
  FormId,
  LeftColumnFields,
  RightColumnFields,
  history,
  NoConfig,
  belong,
}) => {
  return (
    <div>
      <PageWrapper>
        <BackToStandardList history={history} />
        <StyledExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={
              <Tooltip title="Product Details" placement="right-start">
                <ExpandMoreIcon />
              </Tooltip>
            }
          >
            <FirstLineWrapper>
              <Avatar>
                <BookIcon />
              </Avatar>
              <StyledTypography variant="h5">
                {
                  (belong === "MCC"
                    ? ProductsInformationMcc
                    : belong === "pam"
                    ? ProductsInformationPam
                    : ProductsInfomation
                  ).products[FormId].productName
                }
              </StyledTypography>
            </FirstLineWrapper>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <DetailsTypography>
              {
                (belong === "MCC"
                  ? ProductsInformationMcc
                  : belong === "pam"
                  ? ProductsInformationPam
                  : ProductsInfomation
                ).products[FormId].productDescription
              }
            </DetailsTypography>
          </ExpansionPanelDetails>
        </StyledExpansionPanel>
        {!NoConfig && <ConfigurationType />}

        <LongDivider />
        <LeftColumn>{LeftColumnFields}</LeftColumn>
        <RightColumn>
          <TextWrapper>
            <StyledParagraphBold>
              PRODUCT CONFIGURATION DETAILS:
            </StyledParagraphBold>
          </TextWrapper>

          {RightColumnFields}
        </RightColumn>
      </PageWrapper>
    </div>
  );
};

export default GeneralForm;
